import {useTranslation} from '@aboutyou/i18n';
import {useOS} from '@aboutyou/utils';
import {useMemo} from 'react';
import {
  AdjustTracker,
  useGetUnifiedStoreLink,
} from '../../Campaigns/hooks/useGetStoreLink';
import {
  androidBannerData,
  iosBannerData,
  sharedBannerData,
} from './installBannerData';

export function useAppDetails() {
  const OS = useOS();
  const isPlatformAndroid = OS === 'android';
  const isPlatformIos = OS === 'ios';
  const adjustTracker = AdjustTracker.APP_INSTALL_BANNER;
  const {t} = useTranslation();
  const androidTranslation = t('Available in Play Store');
  const iosTranslation = t('Available in App Store');

  const unifiedStoreLink = useGetUnifiedStoreLink({
    adjustTracker,
  });

  return useMemo(() => {
    if (isPlatformAndroid) {
      return {
        ...androidBannerData,
        fallbackLabel: androidTranslation,
        storeUrl: unifiedStoreLink,
      };
    }

    if (isPlatformIos) {
      return {
        ...iosBannerData,
        fallbackLabel: iosTranslation,
        storeUrl: unifiedStoreLink,
      };
    }
    return sharedBannerData;
  }, [
    androidTranslation,
    iosTranslation,
    isPlatformAndroid,
    isPlatformIos,
    unifiedStoreLink,
  ]);
}
